import React from "react";

const SelectionToolbar = ({ selectedCount, onEnable, onDisable, onDelete }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary px-4 py-2 flex max-[400px]:flex-col items-center justify-between gap-2 sm:gap-0">
      <span className="text-xs text-white">
        {selectedCount} user(s) selected
      </span>
      <div className="flex items-center gap-2">
        <button
          onClick={onEnable}
          className="px-3 py-1 text-xs leading-none font-semibold text-primary bg-white hover:bg-white/60 rounded transition-colors"
        >
          ENABLE
        </button>
        <button
          onClick={onDisable}
          className="px-3 py-1 text-xs leading-none font-semibold text-primary bg-white hover:bg-white/60 rounded transition-colors"
        >
          DISABLE
        </button>
        <button
          onClick={onDelete}
          className="px-3 py-1 text-xs leading-none font-semibold text-primary bg-white hover:bg-white/60 rounded transition-colors"
        >
          DELETE
        </button>
      </div>
    </div>
  );
};

export default SelectionToolbar;
